import { ActivityStatusOption } from '../../../utils/types';

export const ACTIVITY_STATUS_OPTIONS: ActivityStatusOption[] = [
  // Clicks Activity
  { id: 'clicks-24h', name: '>0 Clicks (last 24h)', category: 'clicks' },
  { id: 'clicks-7d', name: '>0 Clicks (last 7d)', category: 'clicks' },
  
  // Conversions Activity  
  { id: 'conversions-24h', name: '>0 Conv. (last 24h)', category: 'conversions' },
  { id: 'conversions-7d', name: '>0 Conv. (last 7d)', category: 'conversions' },
  
  // Daily Cap Activity
  { id: 'near-cap', name: 'Near/Over Daily Cap', category: 'cap' }
];

export default ACTIVITY_STATUS_OPTIONS;